export default __webpack_public_path__ + "static/BergenMono-Regular-cf6ea537acbd7e39208334261f95783e.otf";